import { AnimatePresence, motion } from 'framer-motion';
import { FaCheckCircle, FaPrint, FaTimes } from 'react-icons/fa';
import displayNPRCurrency from '../helpers/displayCurrency';

const POSSuccessModal = ({ isOpen, onClose, orderData, onPrint }) => {
    if (!isOpen || !orderData) return null;

    return (
        <AnimatePresence>
            <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
                <motion.div
                    initial={{ opacity: 0, scale: 0.95 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.95 }}
                    className="bg-white rounded-3xl shadow-2xl w-full max-w-md overflow-hidden flex flex-col max-h-[90vh]"
                >
                    {/* Header */}
                    <div className="bg-green-500 p-6 text-center text-white relative">
                        <button 
                            onClick={onClose}
                            className="absolute top-4 right-4 p-2 hover:bg-white/20 rounded-full transition-colors"
                        >
                            <FaTimes />
                        </button>
                        <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4 backdrop-blur-md">
                            <FaCheckCircle className="text-3xl" />
                        </div>
                        <h2 className="text-2xl font-black tracking-tight">Transaction Successful!</h2>
                        <p className="text-green-100 font-medium text-sm">Transaction Completed</p>
                    </div>

                    {/* Receipt Content */}
                    <div className="p-6 overflow-y-auto flex-1 bg-surface-muted/30">
                        <div className="bg-white border border-surface-border rounded-2xl p-4 shadow-sm mb-6 receipt-content">
                            <div className="flex justify-between items-center mb-4 border-b border-dashed border-gray-200 pb-4">
                                <span className="text-xs text-gray-500 font-bold uppercase tracking-widest">Transaction ID</span>
                                <span className="font-mono font-bold text-primary">#{orderData?._id?.slice(-6).toUpperCase() || 'N/A'}</span>
                            </div>

                            <div className="space-y-3 mb-4">
                                {orderData?.products?.map((item, index) => (
                                    <div key={index} className="flex justify-between items-start text-sm">
                                        <div className="flex-1 pr-4">
                                            <span className="font-bold text-gray-700 block">{item.productId?.productName}</span>
                                            <span className="text-xs text-gray-400">Qty: {item.quantity}</span>
                                        </div>
                                        <span className="font-bold text-primary">{displayNPRCurrency(item.price * item.quantity)}</span>
                                    </div>
                                ))}
                            </div>

                            <div className="border-t border-dashed border-gray-200 pt-4 space-y-2">
                                <div className="flex justify-between items-center text-sm">
                                    <span className="text-gray-500">Subtotal</span>
                                    <span className="font-bold">{displayNPRCurrency(orderData?.totalAmount)}</span>
                                </div>
                                <div className="flex justify-between items-center text-sm">
                                    <span className="text-gray-500">Payment</span>
                                    <span className="font-bold text-accent">{orderData?.paymentMethod}</span>
                                </div>
                                <div className="flex justify-between items-center text-lg font-black text-primary pt-2">
                                    <span>Total</span>
                                    <span>{displayNPRCurrency(orderData?.totalAmount)}</span>
                                </div>
                            </div>
                        </div>

                        {/* Actions */}
                        <div className="space-y-3">
                            <button 
                                onClick={onPrint}
                                className="w-full py-4 bg-primary text-white font-black rounded-xl hover:bg-accent transition-all flex items-center justify-center gap-2 shadow-lg shadow-primary/20 active:scale-[0.98]"
                            >
                                <FaPrint /> Print Receipt
                            </button>
                            <button 
                                onClick={onClose}
                                className="w-full py-4 bg-white border-2 border-surface-border text-gray-600 font-black rounded-xl hover:bg-gray-50 transition-all active:scale-[0.98]"
                            >
                                New Transaction
                            </button>
                        </div>
                    </div>
                </motion.div>
            </div>
        </AnimatePresence>
    );
};

export default POSSuccessModal;
